export default function Process() {
  const steps = [
    {
      number: '01',
      title: 'Diagnóstico y Estrategia',
      description:
        'Analizamos tu negocio, mercado y competencia para diseñar una estrategia personalizada alineada con tus objetivos comerciales.',
      icon: 'ri-search-line',
    },
    {
      number: '02',
      title: 'Ejecución',
      description:
        'Implementamos las acciones planificadas con precisión, coordinando todos los canales y recursos necesarios para el éxito.',
      icon: 'ri-tools-line',
    },
    {
      number: '03',
      title: 'Medición y Optimización',
      description:
        'Monitoreamos resultados en tiempo real y ajustamos la estrategia para maximizar el retorno de inversión y alcanzar las metas.',
      icon: 'ri-line-chart-line',
    },
    {
      number: '04',
      title: 'Acompañamiento Continuo',
      description:
        'Mantenemos comunicación constante, reportes periódicos y reuniones estratégicas para asegurar el crecimiento sostenido.',
      icon: 'ri-customer-service-2-line',
    },
  ];

  return (
    <section id="proceso" className="py-20 px-6 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-primary mb-4">
            Cómo trabajamos:
          </h2>
          <p className="text-xl text-secondary max-w-3xl mx-auto">
            Un proceso ordenado y profesional que garantiza resultados medibles
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {steps.map((step, index) => (
            <div
              key={index}
              className="relative bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-all border border-gray-100 hover:border-accent group"
            >
              <div className="flex items-start gap-6">
                <div className="flex-shrink-0">
                  <div className="w-16 h-16 bg-accent/10 rounded-lg flex items-center justify-center group-hover:bg-accent group-hover:scale-110 transition-all">
                    <i className={`${step.icon} text-3xl text-accent group-hover:text-white transition-colors`}></i>
                  </div>
                </div>
                <div className="flex-1">
                  <div className="text-6xl font-bold text-accent/10 absolute top-4 right-6 group-hover:text-accent/20 transition-colors">
                    {step.number}
                  </div>
                  <h3 className="text-xl font-bold text-primary mb-3 relative z-10">
                    {step.title}
                  </h3>
                  <p className="text-secondary leading-relaxed relative z-10">
                    {step.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
